import React from 'react';
import { Chip } from '@mui/material';
import AppIcon from './AppIcon';

const statusConfig: Record<string, { label: string; color: string; bg: string }> = {
  pending: { label: 'Pending', color: '#3D3731', bg: '#E4DED8' },
  not_started: { label: 'Not Started', color: '#3D3731', bg: '#E4DED8' },
  in_progress: { label: 'In Progress', color: '#6A8EB0', bg: 'rgba(106,142,176,0.15)' },
  completed: { label: 'Completed', color: '#6B9E78', bg: 'rgba(107,158,120,0.15)' },
  covered: { label: 'Covered', color: '#6B9E78', bg: 'rgba(107,158,120,0.15)' },
};

interface StatusChipProps {
  status: string;
}

const StatusChip: React.FC<StatusChipProps> = ({ status }) => {
  const config = statusConfig[status] || statusConfig.pending;
  return (
    <Chip
      icon={<AppIcon name="dot" sx={{ fontSize: 10, color: `${config.color} !important` }} />}
      label={config.label}
      size="small"
      sx={{ color: config.color, backgroundColor: config.bg, fontWeight: 500 }}
    />
  );
};

export default StatusChip;
